import { tv } from '~/utils/tv'

export const radioContainerVariants = tv({
  base: `
    flex items-center rounded-pill min-width-size-huge p-onepulse
    active:border-focused focus:border-focused mb-twopulse
  `,
  variants: {
    hasError: {
      true: 'border-forms-border-error border-halfpulse',
    },
    readOnly: {
      // @TODO - Exchange for a semantic token border-action-border-neutral-tertiary-readonly
      true: 'cursor-not-allowed border-[#00000000]',
    },
    disabled: {
      true: 'cursor-not-allowed border-[transparent]',
    },
    hasIconOnly: {
      true: `justify-center overflow-hidden
     `,
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'cursor-not-allowed',
    },
    {
      hasIconOnly: true,
      size: 'md',
      class: '',
    },
    {
      hasIconOnly: true,
      size: 'ml',
      class: '',
    },
    {
      hasIconOnly: true,
      size: 'lg',
      class: '',
    },
    {
      hasIconOnly: true,
      size: 'xl',
      class: '',
    },
  ],
  defaultVariants: {
    size: 'xl',
    hasError: false,
    readOnly: false,
    disabled: false,
    hasIconOnly: false,
  },
})

export const radioVariants = tv({
  base: `
    group flex items-center justify-start rounded-pill min-w-[128px] relative font-wheight-regular
    font-rdmodern font-regular bg-action-fill-neutral-tertiary-enabled border-action-border-neutral-tertiary-enabled
    hover:bg-action-fill-neutral-tertiary-hovered hover:border-action-border-neutral-tertiary-hovered active:bg-action-fill-neutral-tertiary-pressed cursor:pointer
    has-[:focus]:border-action-border-focused border-halfpulse focus:border-action-border-focused focus-visible:border-action-border-focused

  `,
  variants: {
    size: {
      md: 'min-h-medium gap-onepulse px-fourpulse py-onepulse text-threepulse leading-medium',
      ml: 'min-h-mediumlarge gap-twopulse px-fourpulse py-twopulse text-threeandhalfpulse leading-small',
      lg: 'min-h-large gap-twopulse px-fivepulse py-twopulse text-fourpulse leading-small',
      xl: 'min-h-extralarge gap-twopulse px-sixpulse py-threepulse text-fourpulse leading-small',
    },
    hasError: {
      true: `
            bg-action-fill-neutral-tertiary-enabled border-action-border-neutral-tertiary-enabled focus:border-action-border-neutral-tertiary-enabled hover:bg-action-fill-neutral-tertiary-hovered
            active:border-action-border-neutral-tertiary-enabled  has-[:unchecked]:border-none focus-visible:border-action-border-neutral-tertiary-enabled
      `,
    },
    readOnly: {
      // @TODO - Exchange for a semantic token
      true: `
          border-[#00000000] bg-[#00000000] hover:border-[#00000000] hover:bg-[#00000000] focus:border-[#00000000]
          focus:bg-[#00000000] focus-visible:bg-[#00000000] active:border-[#00000000] active:bg-[#00000000]
      `,
    },
    disabled: {
      true: `
          cursor-not-allowed border-action-fill-neutral-tertiary-disabled bg-action-fill-neutral-tertiary-disabled hover:bg-action-fill-neutral-tertiary-disabled
          active:bg-action-fill-neutral-tertiary-disabled active:border-action-border-neutral-tertiary-disabled focus:bg-action-fill-neutral-tertiary-disabled
          focus:border-action-border-neutral-tertiary-disabled focus-visible:bg-action-fill-neutral-tertiary-disabled
      `,
    },
    hasIconOnly: {
      true: `justify-center min-w-[auto] gap-none
      `,
    },
  },
  compoundVariants: [
    {
      readOnly: false,
      disabled: false,
      class: `
        [&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:bg-forms-fill-hovered
      `,
    },
    {
      hasError: false,
      readOnly: false,
      disabled: false,
      class: `

        `,
    },
    {
      hasIconOnly: true,
      size: 'xl',
      class: 'h-extralarge w-extralarge px-threepulse py-threepulse',
    },
    {
      hasIconOnly: true,
      size: 'lg',
      class: 'h-large w-large px-twopulse py-twopulse',
    },
    {
      hasIconOnly: true,
      size: 'ml',
      class: 'h-mediumlarge w-mediumlarge px-twopulse py-twopulse',
    },
    {
      hasIconOnly: true,
      size: 'md',
      class: 'h-medium w-medium px-twopulse py-twopulse',
    },
  ],
  defaultVariants: {
    size: 'xl',
    hasError: false,
    readOnly: false,
    disabled: false,
    hasIconOnly: false,
  },
})

export const RadioLabelVariants = tv({
  base: `
      flex justify-start items-center font-rdmodern text-text-neutral tracking-tiny font-wheight-regular text-left min-h-small line-clamp-4 mt-[5px]
    `,
  variants: {
    size: {
      md: 'min-h-medium text-threepulse leading-medium',
      ml: 'text-threeandhalfpulse leading-small',
      lg: 'text-fourpulse leading-small',
      xl: 'text-fourpulse leading-small',
    },
    readOnly: {
      true: 'text-text-neutral-readonly',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
    hasIconOnly: {
      true: 'hidden',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'cursor-not-allowed text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    readOnly: false,
    disabled: false,
    hasIconOnly: false,
  },
})

export const RadioButtonVariants = tv({
  base: `
    sr-only 
      `,
  variants: {
    hasError: {
      true: 'hidden',
    },
  },
})

export const RadioIcoVariants = tv({
  base: `
      group-has-[:checked]:hidden
      `,
  variants: {
    size: {
      md: 'h-tiny',
      ml: 'h-small',
      lg: 'h-medium',
      xl: 'h-medium',
    },
    readOnly: {
      true: '',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
    },
  },
})

export const RadioIcoCheckedVariants = tv({
  base: `
       hidden group-has-[:checked]:block
      `,
  variants: {
    size: {
      md: 'h-tiny',
      ml: 'h-small',
      lg: 'h-medium',
      xl: 'h-medium',
    },
    readOnly: {
      true: '',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
    },
  },
})
